import React from 'react';
import { assets } from '../data/mock';
import { useTheme } from '../ThemeContext';
import { useT } from '../i18n/useT';

const StatsBar = () => {
  const { isDark } = useTheme();
  const t = useT();

  return (
    <div className="px-[10px] mt-12 lg:mt-16">
      <article className={`w-full relative mx-auto max-w-[1140px] ${isDark ? '' : 'bg-[#17479A]'}`} style={isDark ? { background: 'linear-gradient(135deg, #E6EBF2 0%, #8E98A8 100%)' } : {}}>
        <div className="p-[20px] lg:p-[30px] lg:px-[200px] z-0 relative">
          {!isDark && <img alt="Stats Background" loading="lazy" width="2280" height="322" className="absolute top-0 left-0 w-full h-full object-cover" src={assets.statsBackground} />}
          <div className="flex gap-2 lg:gap-4 items-center justify-evenly relative">
            {t.stats.map((stat, index) => (
              <div key={index}>
                <h4 className="text-center text-[20px] lg:text-[55px] font-bold" style={{ fontFamily: '"Space Grotesk", sans-serif', color: isDark ? '#000000' : 'white' }}>{stat.value}</h4>
                <h5 className="text-center text-[11px] lg:text-[15px] tracking-[0.15em] uppercase" style={{ fontFamily: '"Space Grotesk", sans-serif', color: isDark ? 'rgba(0,0,0,0.7)' : 'white' }}>{stat.label}</h5>
              </div>
            ))}
          </div>
          <div className="h-[62px] lg:h-[124px] w-[62px] lg:w-[124px] absolute top-[-31px] lg:top-[-62px] left-[-31px] lg:left-[-62px] rotate-45 z-10 transition-colors duration-300" style={{ backgroundColor: isDark ? '#000000' : 'white' }} />
          <div className="h-[62px] lg:h-[124px] w-[62px] lg:w-[124px] absolute bottom-[-31px] lg:bottom-[-62px] right-[-31px] lg:right-[-62px] rotate-45 z-10 transition-colors duration-300" style={{ backgroundColor: isDark ? '#000000' : 'white' }} />
        </div>
      </article>
    </div>
  );
};

export default StatsBar;
